<template>
  <v-simple-table v-if="statisticInfo" class="mt-2 mb-2"  dense>
    <template v-slot:default>
      <thead>
      <tr>
        <th v-for="(item, index) in header" :key="index" class="text-left">
          {{ item }}
        </th>
      </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ $t('display/elevator:overview.expanded-field.playouts') }}</td>
          <td>{{ statisticInfo.advertisementsPlayed }}</td>
          <td>{{ statisticInfo.advertisementsToday }}</td>
          <td>{{ statisticInfo.advertisementsYesterday }}</td>
          <td>{{ statisticInfo.advertisementsLast30Days }}</td>
          <td>{{ statisticInfo.advertisementsAverageDay }}</td>
          <td>{{ statisticInfo.advertisementsAverageMonth }}</td>
          <td>{{ statisticInfo.advertisementsAverageYear }}</td>
        </tr>
        <tr>
          <td>{{ $t('display/elevator:overview.expanded-field.motions') }}</td>
          <td>{{ statisticInfo.movementsTotal }}</td>
          <td>{{ statisticInfo.movementsToday }}</td>
          <td>{{ statisticInfo.movementsYesterday }}</td>
          <td>{{ statisticInfo.movementsLast30Days }}</td>
          <td>{{ statisticInfo.movementsAverageDay }}</td>
          <td>{{ statisticInfo.movementsAverageMonth }}</td>
          <td>{{ statisticInfo.movementsAverageYear }}</td>
        </tr>
        <tr>
          <td>{{ $t('display/elevator:overview.expanded-field.generated-on') }}</td>
          <td>{{ statisticInfo.lastStatisticAt }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <div v-else>
    {{ $t('display/elevator:overview.expanded-field.no-statistic') }}
  </div>
</template>

<script>
import ElevatorService from '@/modules/display/services/elevator-service';

export default {
  name: 'ExpandedField',
  props: {
    item: {}
  },
  computed: {
    header() {
      return [
        '',
        this.$t('display/elevator:overview.expanded-field.total'),
        this.$t('display/elevator:overview.expanded-field.today'),
        this.$t('display/elevator:overview.expanded-field.yesterday'),
        this.$t('display/elevator:overview.expanded-field.last-30-days'),
        this.$t('display/elevator:overview.expanded-field.daily-avg'),
        this.$t('display/elevator:overview.expanded-field.monthly-avg'),
        this.$t('display/elevator:overview.expanded-field.yearly-avg'),
      ];
    }
  },
  data() {
    return {
      statisticInfo: null
    }

  },
  created() {
    ElevatorService.getStatistic(this.item.id,
      (response) => {
        this.statisticInfo = response.data;

        if (this.statisticInfo === '') {
          return;
        }

        if (!this.statisticInfo.advertisementsPlayed || this.statisticInfo.advertisementsPlayed === 0) {
          this.statisticInfo.advertisementsPlayed = '-';
        }

        if (!this.statisticInfo.advertisementsToday || this.statisticInfo.advertisementsToday === 0) {
          this.statisticInfo.advertisementsToday = '-';
        }

        if (!this.statisticInfo.advertisementsYesterday || this.statisticInfo.advertisementsYesterday === 0) {
          this.statisticInfo.advertisementsYesterday = '-';
        }

        if (!this.statisticInfo.advertisementsLast30Days || this.statisticInfo.advertisementsLast30Days === 0) {
          this.statisticInfo.advertisementsLast30Days = '-';
        }

        if (!this.statisticInfo.advertisementsAverageDay || this.statisticInfo.advertisementsAverageDay === 0) {
          this.statisticInfo.advertisementsAverageDay = '-';
        }

        if (!this.statisticInfo.advertisementsAverageMonth || this.statisticInfo.advertisementsAverageMonth === 0) {
          this.statisticInfo.advertisementsAverageMonth = '-';
        }

        if (!this.statisticInfo.advertisementsAverageYear || this.statisticInfo.advertisementsAverageYear === 0) {
          this.statisticInfo.advertisementsAverageYear = '-';
        }

        if (this.statisticInfo.movementsTotal === 0) {
          this.statisticInfo.movementsTotal = '-';
        }

        if (this.statisticInfo.movementsToday === 0) {
          this.statisticInfo.movementsToday = '-';
        }

        if (this.statisticInfo.movementsYesterday === 0) {
          this.statisticInfo.movementsYesterday = '-';
        }

        if (this.statisticInfo.movementsLast30Days === 0) {
          this.statisticInfo.movementsLast30Days = '-';
        }

        if (this.statisticInfo.movementsAverageDay === 0) {
          this.statisticInfo.movementsAverageDay = '-';
        }

        if (this.statisticInfo.movementsAverageMonth === 0) {
          this.statisticInfo.movementsAverageMonth = '-';
        }

        if (this.statisticInfo.movementsAverageYear === 0) {
          this.statisticInfo.movementsAverageYear = '-';
        }
      }
    )
  }
}
</script>